var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMainLogoYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.85 72.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fde5b7;\n      }\n\n      .cls-2 {\n        fill: #481f4b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m77.56,66.71c-.23,0-.43-.05-.62-.17s-.33-.26-.44-.44c-.11-.19-.17-.39-.17-.62v-4.91c0-.24.06-.46.19-.65.05-.08.11-.16.19-.23.08-.07.15-.13.23-.17,0,0,.02,0,.03-.01l.1-.05s.05-.02.06-.02c.01,0,.03-.01.04-.02.13-.04.27-.07.4-.07.17,0,.33.03.47.09.15.06.28.15.39.26.11.11.2.24.27.39s.1.31.1.48v2.87h-.82v-2.87c0-.11-.04-.21-.12-.29s-.18-.12-.29-.12-.21.04-.29.12-.12.18-.12.29v4.91s0,.08.02.12c.02.06.04.1.07.14.02.03.04.05.06.06,0,0,0,0,0,0,.07.06.16.09.26.09.11,0,.21-.04.29-.12.08-.08.12-.18.12-.29v-1.23h.82v1.23c0,.06,0,.13-.02.22v.06c-.03.06-.04.11-.05.13-.03.08-.07.16-.12.24-.07.11-.16.21-.26.3h0c-.22.19-.48.28-.78.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m81.22,66.71c-.14,0-.28-.02-.41-.07-.24-.09-.44-.24-.59-.44-.15-.21-.23-.45-.23-.71v-4.91c0-.24.06-.46.19-.65.08-.13.18-.24.29-.32.03-.03.08-.06.15-.1.04-.02.07-.04.11-.05.17-.07.33-.1.48-.1s.28.02.41.07c.24.09.44.24.59.44.15.21.23.45.23.71v4.91c0,.05,0,.1,0,.13,0,0,0,.02,0,.02,0,0,0,.04-.02.12l-.02.07s-.01.04-.02.06h0c-.05.14-.12.26-.19.35-.06.08-.12.14-.18.19h0c-.23.19-.49.28-.78.28Zm0-.82c.11,0,.21-.04.29-.12s.12-.18.12-.29v-4.91c0-.11-.04-.21-.12-.29s-.18-.12-.29-.12-.21.04-.29.12c-.08.08-.12.18-.12.29v4.91c0,.11.04.21.12.29,0,0,.02.02.06.05h0c.06.05.14.07.23.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m85.76,66.71h-2.09v-7.37h.82v6.55h1.28v.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m89.06,66.71h-2.09v-7.37h.82v6.55h1.28v.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m92.36,66.71h-2.09v-7.37h2.09v.82h-1.27v3.28h.82v.82h-.82v1.64h1.27v.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m94.8,66.71c-.23,0-.43-.05-.62-.17s-.33-.26-.44-.44c-.11-.19-.17-.39-.17-.62v-4.91c0-.24.06-.46.19-.65.05-.08.11-.16.19-.23.08-.07.15-.13.23-.17,0,0,.02,0,.03-.01l.1-.05s.05-.02.05-.02c.01,0,.03-.01.04-.02.13-.04.27-.07.4-.07.17,0,.33.03.47.09.15.06.28.15.39.26.11.11.2.24.26.39s.1.31.1.48v2.87h-.82v-2.87c0-.11-.04-.21-.12-.29s-.18-.12-.29-.12-.21.04-.29.12-.12.18-.12.29v4.91s0,.08.02.12c.02.06.04.1.07.14.02.03.04.05.05.06,0,0,0,0,0,0,.07.06.16.09.26.09.11,0,.21-.04.29-.12.08-.08.12-.18.12-.29v-1.23h.82v1.23c0,.06,0,.13-.02.22v.06c-.03.06-.04.11-.05.13-.03.08-.07.16-.12.24-.07.11-.16.21-.26.3h0c-.22.19-.48.28-.78.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m98.39,66.71h-.82v-6.55h-.82v-.82h2.46v.82h-.82v6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m101.23,66.71h-.82v-7.37h.82v7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m104.49,66.71h-.82l-1.23-7.37h.82l.14.82c.23,1.37.46,2.73.68,4.09l.82-4.91h.82l-1.23,7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m109.02,66.71h-2.09v-7.37h2.09v.82h-1.27v3.28h.82v.82h-.82v1.64h1.27v.82Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m5.26,13.59h-1.1v-6.55h-1.1v-.82h3.29v.82h-1.1v6.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m11.28,13.59h-1.1v-2.46h-1.1v2.46h-1.1v-7.37h1.1v4.09h1.1v-4.09h1.1v7.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m15.7,13.59h-2.81v-7.37h2.81v.82h-1.71v3.28h1.1v.82h-1.1v1.64h1.71v.82Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m10.84,15.51h4.53c.4,12.01,5.5,24.71,14.9,32.47V15.51h4.65v41.26c-14.79-8.27-23.86-24.42-24.08-41.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m39.17,56.31V15.51h4.7v40.8h-4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m56.29,55.91c-2.49.57-6.06.4-8.56.4V15.51c.45,0,.91-.06,1.36-.06,2.44,0,5.55.11,7.88.91,4.82,1.64,7.88,6.4,7.88,11.39,0,3.34-.51,4.76-2.72,7.2,2.49,2.72,3.85,4.99,3.85,8.84,0,5.89-3.97,10.82-9.69,12.13Zm-1.64-20.29c3.23-1.19,5.61-3.74,5.61-7.31,0-4.53-3.29-8.1-7.82-8.33v31.79c4.99,0,9.07-2.89,9.07-8.16,0-4.76-2.78-6.63-6.86-7.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m86.27,57.05c-11.5,0-20.68-9.52-20.68-20.97s9.07-21.31,20.68-21.31c4.08,0,8.5,1.25,11.79,3.74v6.06c-3.57-3.29-6.74-5.16-11.79-5.16-8.39,0-14.51,6.06-15.87,14.11h16.89v4.76h-16.89c1.25,8.27,7.42,14.11,15.87,14.11,5.04,0,8.22-1.87,11.79-5.21v6.12c-3.17,2.49-7.82,3.74-11.79,3.74Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogoYellow);
export default __webpack_public_path__ + "static/media/MainLogoYellow.eca5ce589702901e95676d13dbf9c61b.svg";
export { ForwardRef as ReactComponent };